module.exports = __webpack_public_path__ + "static/Gotham-Ultra-f8325585d237e9640f67611f66fbd6ab.woff2";